const ProviderState = Object.freeze({
  Active: 'Activo',
  Inactive: 'Inactivo',
});

export default ProviderState;
